import AppRootView from "./AppRootView";

import "./AppRootView.scss";

export { AppRootView };
